<app-dossier eyebrow="Archives // Erreur 404" reference="Réf. inconnue" [decor]="false">
  <app-page-title
    title="Dossier introuvable"
    lede="Ce dossier n'existe pas, ou il a été détruit."
  />
  <p class="center spaced"><span class="stamp stamp--large">Introuvable</span></p>
  <p class="panel__text spaced">
    Vérifiez le lien reçu. Si l'opération n'a pas encore été validée par l'organisateur, son dossier
    n'est pas encore accessible.
  </p>
  <div class="dossier__footer">
    <a class="button button--primary button--block" routerLink="/">Retour au point de contact</a>
  </div>
</app-dossier>
